import type { IValidatedResponse } from '../../httpClient';
import { getRequest } from '../../httpClient';
import type { IGetFeedTranslationsResponse } from './get-feed-translations-response';
import { getFeedTranslationsResponseSchema } from './get-feed-translations-response';

export async function getFeedTranslationsApi(
  challengeIds: number[],
): Promise<IValidatedResponse<IGetFeedTranslationsResponse>> {
  return getRequest<IGetFeedTranslationsResponse>({
    path: '/feed/translations',
    schema: getFeedTranslationsResponseSchema,
    options: {
      params: { ids: challengeIds.join(',') },
    },
  });
}
